module.exports = __webpack_public_path__ + "static/media/not_found.84b5f083.svg";